import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

function StatsCard({ title, value, change, changeType = 'neutral', icon: Icon, color = 'primary' }) {
  const getChangeIcon = () => {
    switch (changeType) {
      case 'increase':
        return <TrendingUp className="w-4 h-4 text-success-600" />;
      case 'decrease':
        return <TrendingDown className="w-4 h-4 text-danger-600" />;
      default:
        return <Minus className="w-4 h-4 text-slate-500" />;
    }
  };

  const getChangeColor = () => {
    switch (changeType) {
      case 'increase':
        return 'text-success-600';
      case 'decrease':
        return 'text-danger-600';
      default:
        return 'text-slate-500';
    }
  };

  const getIconColor = () => {
    switch (color) {
      case 'success':
        return 'text-success-400 bg-success-900/40 border border-success-800/40';
      case 'warning':
        return 'text-warning-400 bg-warning-900/40 border border-warning-800/40';
      case 'danger':
        return 'text-danger-400 bg-danger-900/40 border border-danger-800/40';
      case 'primary':
      default:
        return 'text-primary-400 bg-primary-900/40 border border-primary-800/40';
    }
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-slate-400">{title}</p>
          <p className="text-3xl font-bold text-slate-100">{value}</p>
          {change !== undefined && (
            <div className={`flex items-center mt-2 ${getChangeColor()}`}>
              {getChangeIcon()}
              <span className="ml-1 text-sm font-medium">{change}</span>
            </div>
          )}
        </div>
        {Icon && (
          <div className={`p-3 rounded-lg ${getIconColor()}`}>
            <Icon className="w-6 h-6" />
          </div>
        )}
      </div>
    </div>
  );
}

export default StatsCard;


